import React from 'react';
import styles from './sections.module.css';

interface CancelOrderSectionProps {
  handleCancelClick: () => void;
}

const CancelOrderSection: React.FC<CancelOrderSectionProps> = ({ handleCancelClick }) => {
  return (
    <button
      className={styles.cancelSection}
      onClick={handleCancelClick}
      data-analytics-id="pp_navrail_cancel_link"
    >
      <span className={styles.cancelTextRegular}>
        Want to <span className={styles.cancelTextLink}>cancel your order?</span>
      </span>
    </button>
  );
};

export default CancelOrderSection;
